import React from 'react';
import ShareButton from "../ShareButton";

function Info(props) {
    const {image,name,type} = props
    return (
        <div className="flex flex-col md:flex-row items-center">
            <img src={image} alt='cover' className='w-[250px] h-[250px] rounded-xl mb-4 md:ml-8'/>
            <div className="flex flex-col text-center md:text-right">
                <div className='text-3xl font-bold mb-4'>{name}</div>
                <div className='text-sm font-medium text-gray-600 mb-2'>{type}</div>
                <ShareButton/>
            </div>
        </div>
    );
}

export default Info;